import { gql } from '@apollo/client'
export const getCustomerQuery = /* GraphQL */ gql`
  query getCustomerForSession {
    customer {
      id
      firstName
      lastName
      displayName
      emailAddress {
        emailAddress
        marketingState
      }
      phoneNumber {
        phoneNumber
        marketingState
      }
      tags
      companyContacts(first: 1) {
        edges {
          node {
            company {
              id
              name
              locations(first: 1) {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export default getCustomerQuery
